// frontend/config.public.js  (browser-safe; no secrets, no Node deps)
export const apiBaseUrl = 'https://zexchange.me';
export const apiBaseSocket = 'wss://zexchange.me';
export const apiBaseParcel = 'https://zexchange.me:8888';
